import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { CMS } from '../shared/CMSData';
import { isNull, momentWrapper, getContentFronStorage } from '../utils/index';
import { makeid } from '../core/index';
import { Link } from 'react-router-dom'; 
export interface RecentBlogProps extends BaseComponentProps {
    // id: string | number;
    lang: string;
    imgWidth?: number;
    count?: number;
    panelColor?: string;
}
export interface RecentBlogState extends BaseComponentState {

    recentBlog?: CMS.CmsBlog[];
    errorMessage: string | any;
    error: boolean;
    requestingBlog: boolean;
    count: number | any;
    imgWidth: number | any;
    panelColor: string | any;
}

export class RecentBlog extends BaseComponent<RecentBlogProps, RecentBlogState> {

    timeout: any = null;

    constructor(props: RecentBlogProps) {
        super(props);
        this.state = {
            requestingBlog: true,
            error: false,
            errorMessage: null,
            count: isNull(props.count) ? 5 : props.count,
            imgWidth: isNull(props.imgWidth) ? 100 : props.imgWidth,
            panelColor: isNull(props.panelColor) ? 'panel-white' : props.panelColor,
        };
    }

    componentDidMount() {
        this.getData();
    }
    getData: () => any = () => {
        this.getRecentBlog();
    }

    getRecentBlog: () => any = () => {
        /*
        new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
            modelName: 'CmsBlog',
            pageSize: this.state.count,
            page: 0,
            orders: [['createdAt', 'desc']]
        }).then(
            d => {
                // console.log("News", d);
                this.setStateHelper(st => {
                    st.recentBlog = d.rows;
                    st.requestingBlog = false;
                });
            }).catch((exc) => { console.error('error: ', exc); });
            */
        getContentFronStorage(this.props.lang, "CmsBlog").then(
            (d: any[]) => {
                let lop = 0;
                let datas: any[] = [];
                for (let e of d) {
                    datas.push(e);
                    lop++;
                    if (lop === this.props.count) {
                        break;
                    }
                }
                this.setStateHelper(st => {
                    st.recentBlog = datas;
                    st.requestingBlog = false;
                });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    componentDidUpdate(prevProps: RecentBlogProps, prevState: RecentBlogState) {
        if (prevProps !== this.props) { this.getData(); }
    }

    getCmsContent: (x: any) => any = (x: any) => {
        return { __html: x };
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let imgSyle = { width: this.state.imgWidth, float: 'left', marginRight: 15 };
        let recenBlog: any[] = [];
        if (this.state.requestingBlog) {
            recenBlog.push(<span key={makeid()} />);
        } else {
            for (let a of this.state.recentBlog!) {
                let img = <img style={imgSyle as any} src={`/uploads/blog/thumb/${a.thumbUrl}`} />;
                if (a.thumbUrl!.substring(0, 4) === 'http') {
                    img = <img style={imgSyle as any} alt="" src={`${a.thumbUrl}`} className="img-responsive" />;
                }
                recenBlog.push(
                    <Link key={makeid()} to={`/${a.slug}`}>
                        <div className='row' style={{ marginBottom: 15, marginLeft: 0 } as any}>
                            {img}
                            {a.metaTitle}<br />
                            {momentWrapper(a["createdAt"]).format("MMMM Do YYYY")}
                        </div>
                    </Link>
                );
            }
        }

        return (
            <div key={makeid()} >
                <h3 key={makeid()} >Recent News</h3>
                <div key={makeid()} className={`panel ${this.state.panelColor}`}>
                    <div key={makeid()} className="panel-body">
                        {recenBlog}
                    </div>
                </div>

            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/core/RecentBlog.tsx